import React from "react";
import PropTypes from "prop-types";

const HeaderCell = ({children}) => {
  return (
    <div className="HeaderCell">
      <div>{children}</div>
    </div>
  );
};

export default HeaderCell;


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/common/header-cell.js